import { FC } from 'react';
import { ROUTES } from '~/routes/routes';
import { Link } from 'react-router-dom';

export const PageFooter: FC = () => {
    return (
        <footer>
            <div className="container footer-container">
                <div className="footer-top">
                    <div className="logo-wrap">
                        <a href="/">
                            <img src="/assets/img/logo.svg" />
                        </a>
                    </div>
                    <div className="footer-top-menu ftm-desktop">
                        <div className="ftm-column">
                            <ul>
                                <li>
                                    <Link target="_blank" rel="noopener" to="https://www.hardrockgames.com/">
                                        Who we are
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        target="_blank"
                                        rel="noopener"
                                        to="https://www.hardrockgames.com/privacy-policy/"
                                    >
                                        Privacy Policy
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="ftm-column">
                            <ul>
                                <li>
                                    <Link target="_blank" rel="noopener" to="https://www.hardrockgames.com/games/">
                                        Games
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        target="_blank"
                                        rel="noopener"
                                        to="https://www.hardrockgames.com/terms-and-conditions/"
                                    >
                                        Terms & Conditions
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="ftm-column">
                            <ul>
                                <li>
                                    <Link to={ROUTES.SUPPORT.path}>Support</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-top-menu ftm-mobile">
                        <div className="ftm-column">
                            <ul>
                                <li>
                                    <Link target="_blank" rel="noopener" to="https://www.hardrockgames.com/">
                                        Who we are
                                    </Link>
                                </li>
                                <li>
                                    <Link to={ROUTES.SUPPORT.path}>Support</Link>
                                </li>
                                <li>
                                    <Link
                                        target="_blank"
                                        rel="noopener"
                                        to="https://www.hardrockgames.com/terms-and-conditions/"
                                    >
                                        Terms & Conditions
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="ftm-column ftm-column-right">
                            <ul>
                                <li>
                                    <Link target="_blank" rel="noopener" to="https://www.hardrockgames.com/games/">
                                        Games
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        target="_blank"
                                        rel="noopener"
                                        to="https://www.hardrockgames.com/privacy-policy/"
                                    >
                                        Privacy Policy
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="footer-bottom-copyright">
                        <div>Copyright © {new Date().getFullYear()} Hard Rock Games.</div>
                        <div className="rights-reserved">All rights reserved</div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
